import { render, staticRenderFns } from "./DSMAccounts.vue?vue&type=template&id=29a80630&"
import script from "./DSMAccounts.vue?vue&type=script&lang=js&"
export * from "./DSMAccounts.vue?vue&type=script&lang=js&"
import style0 from "./DSMAccounts.vue?vue&type=style&index=0&id=29a80630&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports